var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulatorDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20086",
    "data-name": "Rectangle 20086",
    width: 217.607,
    height: 197.556,
    fill: "#d2d5da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    transform: "translate(14141 21653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20124",
    "data-name": "Rectangle 20124",
    width: 250,
    height: 200,
    transform: "translate(-14141 -21653)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4088",
    "data-name": "Group 4088",
    transform: "translate(-14124.804 -21651.777)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M201.66,0H15.947A15.958,15.958,0,0,0,0,15.936V140.122a15.958,15.958,0,0,0,15.947,15.936H40.7V144.709H15.947a4.6,4.6,0,0,1-4.588-4.588V15.936a4.6,4.6,0,0,1,4.588-4.588H201.66a4.6,4.6,0,0,1,4.588,4.588V140.122a4.6,4.6,0,0,1-4.588,4.588H139.65v11.348h62.01a15.958,15.958,0,0,0,15.947-15.936V15.936A15.958,15.958,0,0,0,201.66,0",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M20.95,30.009A13.533,13.533,0,1,0,7.472,16.477,13.533,13.533,0,0,0,20.95,30.009",
    transform: "translate(74.535 29.367)",
    fill: "#d2d5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M101.133,128.164a16.913,16.913,0,0,0-7.683,1.745L50.438,70.039a10.141,10.141,0,0,0,.406-4.61q-3.688-23.674-7.386-47.337c-.34-2.2-.691-4.489-1.1-6.728a6.377,6.377,0,0,0-3.007-4.236c-.23-.154-.351-.384-.593-.516a8.781,8.781,0,0,0-1.416-.439,8.264,8.264,0,0,0-4.719-.362,6.586,6.586,0,0,0-.878.45,6.585,6.585,0,0,0-3.874,3.2Q18.324,28.9,8.787,48.34q-1.35,2.766-2.711,5.488a1.328,1.328,0,0,1-.055.2,7.584,7.584,0,0,0-.79,2.667v.165a7.167,7.167,0,0,0-.209.988v75.28a7.957,7.957,0,1,0,15.914,0v-2.2a7.529,7.529,0,0,0,2.941.6,8.012,8.012,0,0,0,7.957-7.957q-2.382-29.5-4.763-59.025l-.56-6.936,5.433-10.975,2.469,16.3,1.1,6.717a8.012,8.012,0,0,0,9.779,5.554,7.452,7.452,0,0,0,1.723-.867l42.8,59.629c-.066.285-.3.549-.3.845,0,3.677,5.18,6.651,11.579,6.651s11.579-2.974,11.579-6.651-5.18-6.651-11.579-6.651",
    transform: "translate(50.096 56.09)",
    fill: "#d2d5da"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulatorDefault);
export default __webpack_public_path__ + "static/media/simulator-default.9a93011c2e3cd48487e1cdbe7e56ab6c.svg";
export { ForwardRef as ReactComponent };